import windowManager from "common/managers/windowManager";

export default {

    encodeParameter: function(value) {
        return $.ajax({
            url: context.path + "/webservices/rest/login/urlParam/encode",
            method: "GET",
            data: {
                value: value
            }
        });
    },

    getSysProps: function() {
        return $.ajax({
            url: context.path + "/webservices/rest/login/authProps/",
            method: "GET"
        }).then(function(authProps) {
            const props = authProps.sysProps;
            const getString = function(name) {
                const data = props[name];
                return data && data.value ? data.value : "";
            };
            const getBool = function(name) {
                return getString(name).toLowerCase() === "true";
            };
            return {
                trustedAuth: getBool("SYSTEM_AUTHENTICATION_TRUSTEDAUTH_ACTIVE"),
                kerberos: getBool("KERBEROS_ENABLED"),
                username: getString("SYSTEM_AUTHENTICATION_TRUSTEDAUTH_HEADER_ENCRYPTEDUSERNAME"),
                password:  getString("SYSTEM_AUTHENTICATION_TRUSTEDAUTH_HEADER_ENCRYPTEDPASSWORD")
            };
        });
    },

    resetPassword: function(username) {
        return $.ajax({
            url: context.path + "/webservices/rest/login/reset",
            method: "POST",
            data: {
                username: username
            }
        });
    },

    changePassword: function(username, oldPassword, newPassword) {
        return $.ajax({
            url: context.path + "/webservices/rest/login/change",
            method: "POST",
            data: {
                "username": username,
                "oldPassword": oldPassword,
                "newPassword": newPassword
            }
        });
    },

    /**
     * Logout without navigating the browser.
     * @returns {*}
     */
    asyncLogout: function() {
        return $.ajax({
            url: context.path + "/auth/doLogout",
            method: "POST"
        });
    },

    logout: function() {
        if (window.location.hostname === "127.0.0.1") {
            window.close();
        } else {
            // use the current hash, so they log in to the place they just came from
            window.location.href = context.path + "/auth/logout/return?url=" + encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
        }
    }
}
